import React, { useState } from 'react';
import { getApiUrl } from '../config/apiConfig';

const CierreMesComponent = ({ token }) => {
    const [fechaCorte, setFechaCorte] = useState('');
    const [confirmacionText, setConfirmacionText] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    const handleCierre = async () => {
        if (!fechaCorte) {
            setError('Por favor, selecciona una fecha de corte.');
            return;
        }
        if (confirmacionText !== 'CONFIRMAR CIERRE') {
            setError('Debes escribir "CONFIRMAR CIERRE" para ejecutar esta acción.');
            return;
        }

        setError('');
        setMessage('');
        setIsLoading(true);

        try {
            const res = await fetch(getApiUrl('/mantenimiento/cierre-mes'), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ fecha_corte: fechaCorte })
            });

            const data = await res.json();

            if (!res.ok) {
                throw new Error(data.message || 'Error al ejecutar el cierre de mes.');
            }

            setMessage('Cierre de mes ejecutado exitosamente. Se ha purgado el historial.');
            setFechaCorte('');
            setConfirmacionText('');
            
            // Si el backend devuelve la URL para descargar el Excel, iniciar descarga:
            if (data.downloadUrl) {
                window.open(getApiUrl(data.downloadUrl).replace('/api/exports', '/exports'), '_blank');
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto', background: '#fff', borderRadius: '10px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
            <h2 style={{ color: '#d32f2f', borderBottom: '2px solid #ffcdd2', paddingBottom: '10px' }}>
                ⚠️ Sistema de Cierre de Mes (Destructivo)
            </h2>
            
            <div style={{ background: '#fff3cd', borderLeft: '5px solid #ffecb5', padding: '15px', marginBottom: '20px', borderRadius: '4px' }}>
                <p style={{ margin: 0, color: '#856404' }}>
                    <strong>¡Atención!</strong> Esta acción limpiará la base de datos para todas las fechas registradas hasta la hora de la <strong>fecha seleccionada</strong> (inclusive).
                    Se eliminarán Pedidos, Compras, Movimientos de Caja y el Historial de Insumos.
                </p>
                <p style={{ margin: '10px 0 0 0', color: '#856404' }}>
                    El sistema de insumos conservará su stock actual como "Saldo Inicial" para el nuevo ciclo, y se autogenerará
                    un archivo <strong>Excel</strong> con sus datos eliminados para su posterior revisión contable.
                </p>
            </div>

            <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '8px' }}>Fecha y Hora exactas de Cierre (Se borrará todo hasta este momento):</label>
                <input 
                    type="datetime-local" 
                    value={fechaCorte} 
                    onChange={e => setFechaCorte(e.target.value)}
                    disabled={isLoading}
                    style={{ padding: '10px', width: '100%', maxWidth: '300px', borderRadius: '5px', border: '1px solid #ccc' }}
                />
            </div>

            <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '8px', color: '#d32f2f' }}>
                    Escribe "CONFIRMAR CIERRE" para habilitar el botón:
                </label>
                <input 
                    type="text" 
                    placeholder="CONFIRMAR CIERRE"
                    value={confirmacionText} 
                    onChange={e => setConfirmacionText(e.target.value)}
                    disabled={isLoading}
                    style={{ padding: '10px', width: '100%', maxWidth: '300px', borderRadius: '5px', border: '2px solid #d32f2f' }}
                />
            </div>

            {error && <div style={{ color: 'white', background: '#d32f2f', padding: '10px', borderRadius: '5px', marginBottom: '15px' }}>{error}</div>}
            {message && <div style={{ color: 'white', background: '#388e3c', padding: '10px', borderRadius: '5px', marginBottom: '15px' }}>{message}</div>}

            <button 
                onClick={handleCierre} 
                disabled={isLoading || confirmacionText !== 'CONFIRMAR CIERRE' || !fechaCorte}
                style={{
                    backgroundColor: (confirmacionText === 'CONFIRMAR CIERRE' && fechaCorte && !isLoading) ? '#d32f2f' : '#ccc',
                    color: 'white',
                    padding: '12px 24px',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: (confirmacionText === 'CONFIRMAR CIERRE' && fechaCorte && !isLoading) ? 'pointer' : 'not-allowed',
                    fontWeight: 'bold',
                    fontSize: '16px'
                }}
            >
                {isLoading ? 'Ejecutando Cierre (No cerrar ventana)...' : 'Ejecutar Cierre de Mes y Generar Excel'}
            </button>
        </div>
    );
};

export default CierreMesComponent;
